import { InjectionToken } from '@angular/core';

export type NewsSummaryAppearance = 'compact' | 'normal';

export const NEWS_SUMMARY_APPEARANCE = new InjectionToken<NewsSummaryAppearance>(
	'NEWS_SUMMARY_APPEARANCE_TOKEN', {
		factory: () => 'normal',
	},
);
